module.exports = __webpack_public_path__ + "assets/img/FeaturedTools.840c677a.png";